import { createContext, useContext, useEffect, useState } from "react";
import es from "../i18n/es";
import en from "../i18n/en";
import fr from "../i18n/fr";

const translations = { es, en, fr };
const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("cs_lang") || "es");

  useEffect(() => {
    localStorage.setItem("cs_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.es;

  return (
    <I18nContext.Provider value={{ lang, setLang, t, languages: [["es", "ES"], ["en", "EN"], ["fr", "FR"]] }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
